export default __webpack_public_path__ + "static/media/double.420c2c16.mp3";